<template>
  <div>
    <PageAllow controller="Payment" action="getPaySettings" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("Payment.alipay_h5.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.alipay_h5.application") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  一言为订 移动订货App（Android、iOS）
                </v-col>
              </v-row>
              <!-- APPID -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.alipay_h5.APPID") + $t("Global.colon") }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.alipay_h5.APPID')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.alipay_app_id"
                      single-line
                      :hint="$t('Payment.alipay_h5.PID')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'alipay_app_id')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- 账号 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.alipay_h5.account") + $t("Global.colon") }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.alipay_h5.account')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.alipay_account"
                      single-line
                      :hint="$t('Payment.alipay_h5.accountHint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'alipay_account')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- 校验码 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.alipay_h5.alipay_merchant_md5") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.alipay_h5.alipay_merchant_md5')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.alipay_merchant_md5"
                      :hint="$t('Payment.alipay_h5.md5Hint')"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'alipay_merchant_md5')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- 公钥 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.alipay_h5.alipay_public_key") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.alipay_h5.alipay_public_key')"
                    rules="required"
                  >
                    <v-textarea
                      v-model="settings.alipay_public_key"
                      outlined
                      :hint="$t('Payment.alipay_h5.publicHint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'alipay_public_key')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- 私钥 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.alipay_h5.alipay_merchant_private_key") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.alipay_h5.alipay_merchant_private_key')"
                    rules="required"
                  >
                    <v-textarea
                      v-model="settings.alipay_merchant_private_key"
                      outlined
                      :hint="$t('Payment.alipay_h5.privateHint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(
                            serverErrors,
                            'alipay_merchant_private_key'
                          )
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- 启用 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.alipay_h5.alipay_h5_enable") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="settings.alipay_h5_enable">
                    <v-radio :label="$t('Payment.off')" key="0" value="0" />
                    <v-radio :label="$t('Payment.on')" key="1" value="1" />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <!-- 保存 -->
              <v-btn color="success" block @click="save()">
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("Payment.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import Payment from "@/api/payment";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
// import Required from "@/components/plugins/Required";

export default {
  data: () => ({
    settings: {},
    serverErrors: [],
  }),
  components: {
    PageAllow,
    Breadcrumbs,
    // Required,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.payment"),
        disabled: true,
        href: "/payment",
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getAlipayFromAPI();
  },
  methods: {
    getAlipayFromAPI() {
      Payment.fetch({
        keys: [
          "alipay_app_id",
          "alipay_account",
          "alipay_merchant_md5",
          "alipay_public_key",
          "alipay_merchant_private_key",
          "alipay_h5_enable",
        ],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settings = response.data.settings;
            if (
              this.settings.alipay_h5_enable == null ||
              typeof this.settings.alipay_h5_enable == "undefined" ||
              this.settings.alipay_h5_enable == undefined
            ) {
              this.settings.alipay_h5_enable = "0";
            }
          }
        }.bind(this)
      );
    },

    save() {
      Payment.alipaySave(this.settings).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.push("/payment");
          }
        }.bind(this)
      );
    },
  },
};
</script>

<style>
</style>